import React from "react"
import { slugify } from "src/utils/format"

import PageIntro from "src/components/PageIntro"
import PageIntroSlider from "src/components/PageIntroSlider"
import JobsListing from "src/components/JobsListing"
import TextSection from "src/components/TextSection"
import WideMedia from "src/components/WideMedia"
import FiftyFifty from "src/components/FiftyFifty"
import Columns from "src/components/Columns"
import TwoColumnText from "src/components/TwoColumnText"
import Financing from "src/components/Financing"
import Reviews from "src/components/Reviews"
import Faqs from "src/components/Faqs"
import LogoTicker from "src/components/LogoTicker"
import DesktopSlider from "src/components/DesktopSlider"
import MobileSteps from "src/components/MobileSteps"
import ImageCollage from "src/components/ImageCollage"
import CtaBar from "src/components/CtaBar"
import TeamGrid from "src/components/TeamGrid"
import HowItWorks from "src/components/HowItWorks"
import ArticleSlider from "src/components/ArticleSlider"
import FeaturedPartners from "src/components/FeaturedPartners"
import DetailCards from "src/components/DetailCards"
import OfferKoalafi from "src/components/OfferKoalafi"
import PartnerList from "src/components/PartnerList"
import ContactFormSection from "src/components/ContactFormSection"
import Testimonials from "src/components/Testimonials"
import Table from "src/components/Table"
import EmbedCode from "src/components/EmbedCode"
import Merchants from "src/components/Merchants"
import IFrame from "src/components/IFrame"
import TextSectionBackground from "src/components/TextSectionBackground"
import AppPreview from "src/components/AppPreview"

const componentMap = {
  pageIntro: PageIntro,
  pageIntroSlider: PageIntroSlider,
  textSection: TextSection,
  textSectionBackground: TextSectionBackground,
  appPreview: AppPreview,
  merchants: Merchants,
  wideMedia: WideMedia,
  testimonials: Testimonials,
  fiftyFifty: FiftyFifty,
  columns: Columns,
  financing: Financing,
  twoColumnText: TwoColumnText,
  reviews: Reviews,
  faqs: Faqs,
  logoTicker: LogoTicker,
  desktopSlider: DesktopSlider,
  mobileSteps: MobileSteps,
  mediaCollage: ImageCollage,
  ctaBar: CtaBar,
  contactForm: ContactFormSection,
  teamGrid: TeamGrid,
  animatedHowItWorks: HowItWorks,
  blogArticles: ArticleSlider,
  featuredPartners: FeaturedPartners,
  detailCards: DetailCards,
  offerKoalafi: OfferKoalafi,
  partnerList: PartnerList,
  jobsListing: JobsListing,
  table: Table,
  embed: EmbedCode,
  iframe: IFrame,
}

const ComponentRenderer = ({
  item,
  prevTheme,
  nextTheme,
  index,
  isLastSection,
  isFirstSection,
}) => {
  if (!item || !item?._type) {
    console.warn(`Page Component Error`)
    return false
  }
  const Component = componentMap[item._type]
  if (!Component) {
    console.warn(
      `Page Component [${item._type}] : [${item.internalName}] Not Found`
    )
    return false
  }

  return Component ? (
    <Component
      {...item}
      prevTheme={prevTheme}
      nextTheme={nextTheme}
      id={slugify(item.internalName)}
      isLastSection={isLastSection}
      isFirstSection={isFirstSection}
      index={index}
    />
  ) : null
}

export default ComponentRenderer
